import { PostDeleteSourceDataEvent, SourceDataEvent } from "@/api/dtos";
import ServiceStackClientContext from "@/contexts/api/ServiceStackClientContext";
import { useCallback, useContext } from "react";

const useDeleteSourceDataEvent = () => {
    const client = useContext(ServiceStackClientContext);

    const deleteAction = useCallback(async (event?: SourceDataEvent) => {
        if(!event) {
            return undefined;
        }

        return await client.post(new PostDeleteSourceDataEvent({event}))
    }, [client])

    return deleteAction;
}

export default useDeleteSourceDataEvent;